module.exports = __webpack_public_path__ + "img/asrarEl3od.c79ace31.jpeg";